export const RESEND_COOLDOWN_MS = 60_000;

export function canResendNow(lastSentAt: number | null, now = Date.now()): boolean {
  if (lastSentAt == null) return true;
  return now - lastSentAt >= RESEND_COOLDOWN_MS;
}

export function secondsUntilResend(lastSentAt: number | null, now = Date.now()): number {
  if (lastSentAt == null) return 0;
  return Math.max(0, Math.ceil((RESEND_COOLDOWN_MS - (now - lastSentAt)) / 1000));
}

/**
 * Never tell the caller whether an address has an account.
 * Supabase may return "user not found" or similar; we collapse those.
 */
export function sanitizeResendError(message: string | null | undefined): string {
  const text = (message || '').toLowerCase();
  if (
    text.includes('not found') ||
    text.includes('does not exist') ||
    text.includes('already confirmed') ||
    text.includes('user not') ||
    text.includes('unable to find')
  ) {
    return 'If that address can receive a confirmation email, we sent one.';
  }
  if (text.includes('rate') || text.includes('too many') || text.includes('security purposes')) {
    return 'Please wait a minute before requesting another email.';
  }
  return 'If that address can receive a confirmation email, we sent one.';
}

export function resendSuccessMessage(): string {
  return 'If that address can receive a confirmation email, we sent one.';
}
